export default __webpack_public_path__ + "static/media/IMG_7091.0194feb4.webp";